/**
 * Secret Place accusation windup — Empty Words arrow / imminent glow.
 */
import { LAYER_ORDER } from "./types";
import type { LayerId } from "./types";
import type { BoardState } from "./board";
import type { Presence } from "../cards/types";

export const TAX_INTENT_SHOW = 0.08;
export const TAX_INTENT_IMMINENT = 0.72;

export interface TaxIntent {
  presenceId: string;
  fromLayer: LayerId;
  fromSlot: number;
  /** 0..1 windup toward the Secret Place */
  progress: number;
}

export function taxProgressOf(presence: Presence): number {
  if (!presence.verbs.taxAfter) return 0;
  return Math.max(0, Math.min(1, presence.taxProgress ?? 0));
}

export function resolveTaxIntent(
  layer: LayerId,
  slot: number,
  presence: Presence,
): TaxIntent | null {
  if (presence.side !== "enemy" || presence.level <= 0) return null;
  const progress = taxProgressOf(presence);
  if (progress < TAX_INTENT_SHOW) return null;
  return {
    presenceId: presence.instanceId,
    fromLayer: layer,
    fromSlot: slot,
    progress,
  };
}

export function collectTaxIntents(board: BoardState): TaxIntent[] {
  const out: TaxIntent[] = [];
  for (const id of LAYER_ORDER) {
    board[id].slots.forEach((p, slot) => {
      if (!p) return;
      const intent = resolveTaxIntent(id, slot, p);
      if (intent) out.push(intent);
    });
  }
  return out;
}
